import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/App";

const LogoContext = createContext(null);

export const useLogo = () => useContext(LogoContext);

export const LogoProvider = ({ children }) => {
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLogo = useCallback(async () => {
    try {
      const res = await api.get("/logo");
      if (res.data.has_logo) {
        const dataUrl = `data:${res.data.content_type};base64,${res.data.logo}`;
        setLogo(dataUrl);
      } else {
        setLogo(null);
      }
    } catch (error) {
      console.error("Failed to fetch logo:", error);
      setLogo(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLogo();
  }, [fetchLogo]);

  const refreshLogo = () => {
    fetchLogo();
  };

  return (
    <LogoContext.Provider value={{ logo, loading, refreshLogo }}>
      {children}
    </LogoContext.Provider>
  );
};

export default LogoProvider;
